import { CometChat } from '@cometchat-pro/chat';

import {
  authorizeChatUser,
  setUnreadMessagesCount,
  updateUnreadMessagesCount,
} from '@lootboy/lib/slices/cometChat';

const REGION = 'eu';
const MESSAGE_COUNT_LISTENER = 'MESSAGE_COUNT_LISTENER';

// prawdziwy JSowy OOP
const createCometChatAppSettingsGetter = () => {
  let appSettings;

  return () => {
    if (appSettings) {
      return appSettings;
    }

    appSettings = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(REGION)
      .autoEstablishSocketConnection(true)
      .build();
    return appSettings;
  };
};

const getCometChatAppSettings = createCometChatAppSettingsGetter();

// currently opened conversation to not increase counter if message from it
let currentConversationId = '';

export const setCurrentConversationId = (id) => {
  currentConversationId = id;
};

export const syncUnreadMessagesCount = async (dispatch) => {
  const user = await CometChat.getLoggedinUser();
  if (user) {
    try {
      const unreadMessagesMap =
        await CometChat.getUnreadMessageCountForAllUsers(true);
      const unreadMessagesCount = Object.values(unreadMessagesMap || {}).reduce(
        (acc, val) => acc + val,
        0,
      );
      dispatch(setUnreadMessagesCount(unreadMessagesCount));
    } catch (e) {
      // todo: add logging
    }
  }
};

export async function loginCometChat(dispatch) {
  try {
    await CometChat.init(
      process.env.REACT_APP_COMET_CHAT_APP_ID,
      getCometChatAppSettings(),
    );
    const authToken = await dispatch(
      authorizeChatUser(process.env.REACT_APP_RADAR_API_URL),
    );
    await CometChat.login(authToken);
    await syncUnreadMessagesCount(dispatch);
    const messageHandler = (message) => {
      if (message?.conversationId !== currentConversationId) {
        dispatch(updateUnreadMessagesCount(1));
      }
    };
    CometChat.addMessageListener(
      MESSAGE_COUNT_LISTENER,
      new CometChat.MessageListener({
        onTextMessageReceived: messageHandler,
        onMediaMessageReceived: messageHandler,
        onCustomMessageReceived: messageHandler,
      }),
    );
  } catch {
    // do sth
  }
}

export async function reInitializeCometChat(dispatch) {
  if (!CometChat.isInitialized() || !(await CometChat.getLoggedinUser())) {
    return loginCometChat(dispatch);
  }
  return null;
}

export const logoutCometChat = async () => {
  try {
    await CometChat.logout();
  } catch (e) {
    // do sth
  }
};
